import React from 'react';

import { Alert, Button, Stack, Typography } from '@mui/material';

import type { BuildFlightCampaignResult, BuildPublishMode } from '~/services/FlightsService';
import { formatDateWithClock } from '~/services/TimeService';

interface Props {
  preview: BuildFlightCampaignResult;
  busy: boolean;
  onSave: (publish: BuildPublishMode) => void;
}

export default function PreviewStep({ preview, busy, onSave }: Props) {
  return (
    <Stack gap={2}>
      <Typography variant="h6">Review the generated deal</Typography>
      {preview.rows.map((row, index) => (
        <Stack key={index} gap={1}>
          <Typography fontWeight={600}>{row.dealName}</Typography>
          <Typography>
            {row.originAirportCode} to {row.destinationAirportCode} · {row.carrierCode} · {row.fareClass}
          </Typography>
          <Typography>
            ${row.perAdultPrice} per adult
            {row.luxPlusPerAdultPrice != null ? ` · Lux Plus $${row.luxPlusPerAdultPrice}` : ''}
          </Typography>
          <Typography>Booking class {row.bookingClassCode}</Typography>
          {row.salesStartDate && (
            <Typography>
              On sale {formatDateWithClock(row.salesStartDate)} to {formatDateWithClock(row.salesEndDate)}
            </Typography>
          )}
        </Stack>
      ))}
      {preview.issues.map((issue, index) => (
        <Alert key={index} severity={issue.severity}>
          {issue.message}
        </Alert>
      ))}
      {!preview.issues.some((issue) => issue.severity === 'error') && preview.rows.length > 0 && (
        <Stack direction="row" gap={2}>
          <Button variant="contained" disabled={busy} onClick={() => onSave('now')}>
            Publish campaign and deal
          </Button>
          <Button variant="outlined" disabled={busy} onClick={() => onSave('scheduled')}>
            Schedule for sale start
          </Button>
          <Button disabled={busy} onClick={() => onSave('draft')}>
            Save draft
          </Button>
        </Stack>
      )}
    </Stack>
  );
}
